export default __webpack_public_path__ + "static/media/EAST3070.34I-39225_-23178_0.01a71075.jpg";